var render, staticRenderFns
import script from "./AssetIcon.vue?vue&type=script&lang=js"
export * from "./AssetIcon.vue?vue&type=script&lang=js"
import style0 from "./AssetIcon.vue?vue&type=style&index=0&id=79f2f4cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2f4cd",
  null
  
)

export default component.exports